import { useTranslation } from '../../../lib/i18n';
import { useMaestroBrief } from '../../../lib/use-maestro-brief';
import { Button } from '../ui';
import { AgentDot } from '../../AgentDot';
import { BriefMark } from './BriefMark';
import { BriefHeadlinePositional } from './BriefHeadlinePositional';
import { BriefArrowIcon } from './BriefArrowIcon';
import { BriefListenButton } from './BriefListenButton';
import { BRIEF_HEADLINE, BRIEF_HEADLINE_ACCENT, BRIEF_META_TEXT } from './styles';

export function MaestroBrief() {
  const { t } = useTranslation();
  const brief = useMaestroBrief();

  if (!brief) return null;
  const { agentIds, agentCount, title, time, inProgress, headline, open } = brief;
  const baseLabel = title || t('brief.title', { time });
  const label = inProgress ? `${baseLabel} · ${t('brief.inProgress')}` : baseLabel;
  const heroHeadline = inProgress ? t('brief.inMotionHeadline') : headline;

  return (
    <div style={{ textAlign: 'start' }}>
      <div className="brief-reveal" style={{ display: 'flex', alignItems: 'center', gap: 16, rowGap: 10, marginBottom: 12, flexWrap: 'wrap', animationDelay: '0s' }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
          <BriefMark size={20} />
          <span style={{ ...BRIEF_META_TEXT, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {label}
          </span>
        </span>
        {agentCount > 0 && (
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
              {agentIds.slice(0, 4).map((id, i) => (
                <span key={id} style={{ marginInlineStart: i === 0 ? 0 : -8, display: 'inline-flex' }}>
                  <AgentDot id={id} size={20} />
                </span>
              ))}
            </span>
            <span style={BRIEF_META_TEXT}>
              {agentCount} {t(agentCount === 1 ? 'island.agent' : 'island.agents')}
            </span>
          </span>
        )}
      </div>

      {heroHeadline && (
        <div className="brief-reveal" style={{ ...BRIEF_HEADLINE, marginBottom: 20, animationDelay: '0.08s' }}>
          <BriefHeadlinePositional text={heroHeadline} accentStyle={BRIEF_HEADLINE_ACCENT} />
        </div>
      )}

      {/* The CTA and the listen affordance share a center-aligned flex row (matching the mobile hero) so
          the icon button lines up with the primary button rather than sitting on its text baseline —
          two bare inline-flex siblings align by baseline, which left the speaker box vertically off. */}
      <div className="brief-reveal" style={{ display: 'flex', alignItems: 'center', gap: 8, animationDelay: '0.16s' }}>
        <Button size="large" onClick={open} endIcon={<BriefArrowIcon />}>
          {t('brief.seeFullBrief')}
        </Button>

        {/* Listening is an alternative to reading it, so it sits beside the open CTA rather than
            inside the thread. A ghost volume-2 icon button (matching mobile web + native), sized to
            the primary CTA beside it. Secondary: opening the brief is still the primary action. */}
        <BriefListenButton iconOnly size="large" />
      </div>
    </div>
  );
}
